!(function () {
    "use strict";
    const e = "[data-collection-sidebar]",
        t = "[data-collection-sidebar-slide-out]",
        i = "[data-collection-sidebar-close]",
        s = "[data-aria-toggle]",
        o = "drawer--animated",
        l = "expanded",
        n = "no-mobile-animation",
        c = "is-focused";
    customElements.get("collection-component") ||
        customElements.define(
            "collection-component",
            class extends HTMLElement {
                constructor() {
                    super(),
                        (this.collectionSidebar = this.querySelector(e)),
                        (this.groupTagsButton = this.querySelector(s)),
                        (this.a11y = window.theme.a11y),
                        (this.groupTagsButtonClickEvent = (e) => this.groupTagsButtonClick(e)),
                        (this.sidebarResizeEvent = () => this.toggleSidebarSlider()),
                        (this.collectionSidebarCloseEvent = (e) => this.collectionSidebarClose(e));
                    }
                    connectedCallback() {
                    if (null !== this.groupTagsButton) {
                        document.addEventListener("theme:resize:width", this.sidebarResizeEvent),
                            this.groupTagsButton.addEventListener("click", this.groupTagsButtonClickEvent),
                            this.collectionSidebar &&
                                setTimeout(() => {
                                    console.log(this.collectionSidebar.classList, '==> this.collectionSidebar.classList')
                                    console.log(n,  '==> nn')
                                    this.collectionSidebar.classList.remove(n);
                                }, 1e3);
                                console.log(e, '==> ee', this.groupTagsButton)
                        new MutationObserver((e) => {
                            console.log(this.groupTagsButton, '==>this.groupTagsButton',e, 'ee')
                            for (const t of e)

                                if ("attributes" === t.type) {
                                    "true" == t.target.getAttribute("aria-expanded") && this.showSidebarCallback();
                                }
                        }).observe(this.groupTagsButton, { attributes: !0, childList: !1, subtree: !1 });
                    }
                    this.addEventListener("keyup", (e) => {
                        "Escape" === e.code && this.hideSidebar();
                    }),
                        this.collectionSidebar &&
                            (this.collectionSidebar.addEventListener("transitionend", () => {
                                this.collectionSidebar.classList.contains(l) || this.collectionSidebar.classList.remove(o);
                            }),
                            this.toggleSidebarSlider(),
                            this.addEventListener("theme:filter:close", this.collectionSidebarCloseEvent));
                }
                showSidebarCallback() {
                    console.log(this.collectionSidebar , '==> showSidebarCallback', null !== this.groupTagsButton)

                    const e = this.querySelector(t),
                        s = document.documentElement.hasAttribute("data-scroll-locked"),
                        l = window.theme.isMobile();
                        console.log(this.collectionSidebar, '==>this.collectionSidebar ')
                    this.collectionSidebar.classList.add(o),
                        null === e && !l && s && (this.a11y.removeTrapFocus(), document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }))),
                        (l || null !== e) && (e && this.a11y.trapFocus(this.collectionSidebar, { elementToFocus: this.collectionSidebar.querySelector(i) }), document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })));
                }
                hideSidebar() {
                    const e = this.querySelector(t),
                        i = document.documentElement.hasAttribute("data-scroll-locked");
                    this.groupTagsButton.setAttribute("aria-expanded", "false"),
                        this.collectionSidebar.classList.remove(l),
                        e && this.a11y.removeTrapFocus(),
                        i && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                }
                toggleSidebarSlider() {
                    window.theme.isMobile() ? this.hideSidebar() : this.collectionSidebar.classList.contains(l) && this.showSidebarCallback();
                }
                collectionSidebarClose(e) {
                    e.preventDefault(), this.hideSidebar(), document.body.classList.contains(c) && this.groupTagsButton && this.groupTagsButton.focus();
                }
                groupTagsButtonClick() {
                    document.documentElement.hasAttribute("data-scroll-locked") && document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                }
                disconnectedCallback() {
                    null !== this.groupTagsButton && (document.removeEventListener("theme:resize:width", this.sidebarResizeEvent), this.groupTagsButton.removeEventListener("click", this.groupTagsButtonClickEvent)),
                        this.collectionSidebar && this.removeEventListener("theme:filter:close", this.collectionSidebarCloseEvent);
                }
            }
        );

        function equalHeights() {
            const items = [...document.querySelectorAll('.swatches-title-container')];
            if (!items.length) return;

            items.forEach(item => item.style.height = 'auto');

            for (let i = 0; i < items.length; i += 2) {
                const group = items.slice(i, i + 2);
                let maxHeight = 0;

                group.forEach(item => {
                    maxHeight = Math.max(maxHeight, item.offsetHeight);
                });

                group.forEach(item => {
                    item.style.height = maxHeight + 'px';
                });
            }
        }

        // Observe visibility
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    equalHeights();
                }
            });
        }, { threshold: 0.1 });

        // Attach observer
        document.querySelectorAll('.swatches-title-container').forEach(el => {
            observer.observe(el);
        });

        // Also run initially
        window.addEventListener("load", equalHeights);
        window.addEventListener("resize", equalHeights);
        document.addEventListener("DOMContentLoaded", () => {
            requestAnimationFrame(() => {
                requestAnimationFrame(equalHeights);
            });
        });  
})();
